module.exports = {
	"description": "A list of English verbs.",
	"verbs": [
		{
			"present": "accept",
			"past": "accepted"
		},
		{
			"present": "add",
			"past": "added"
		},
		{
			"present": "admire",
			"past": "admired"
		},
		{
			"present": "admit",
			"past": "admitted"
		},
		{
			"present": "advise",
			"past": "advised"
		},
		{
			"present": "afford",
			"past": "afforded"
		},
		{
			"present": "agree",
			"past": "agreed"
		},
		{
			"present": "alert",
			"past": "alerted"
		},
		{
			"present": "allow",
			"past": "allowed"
		},
		{
			"present": "amuse",
			"past": "amused"
		},
		{
			"present": "analyse",
			"past": "analysed"
		},
		{
			"present": "announce",
			"past": "announced"
		},
		{
			"present": "annoy",
			"past": "annoyed"
		},
		{
			"present": "answer",
			"past": "answered"
		},
		{
			"present": "apologise",
			"past": "apologised"
		},
		{
			"present": "appear",
			"past": "appeared"
		},
		{
			"present": "applaud",
			"past": "applauded"
		},
		{
			"present": "appreciate",
			"past": "appreciated"
		},
		{
			"present": "approve",
			"past": "approved"
		},
		{
			"present": "argue",
			"past": "argued"
		},
		{
			"present": "arrange",
			"past": "arranged"
		},
		{
			"present": "arrest",
			"past": "arrested"
		},
		{
			"present": "arrive",
			"past": "arrived"
		},
		{
			"present": "ask",
			"past": "asked"
		},
		{
			"present": "attach",
			"past": "attached"
		},
		{
			"present": "attack",
			"past": "attacked"
		},
		{
			"present": "attempt",
			"past": "attempted"
		},
		{
			"present": "attend",
			"past": "attended"
		},
		{
			"present": "attract",
			"past": "attracted"
		},
		{
			"present": "avoid",
			"past": "avoided"
		},
		{
			"present": "back",
			"past": "backed"
		},
		{
			"present": "bake",
			"past": "baked"
		},
		{
			"present": "balance",
			"past": "balanced"
		},
		{
			"present": "ban",
			"past": "banned"
		},
		{
			"present": "bang",
			"past": "banged"
		},
		{
			"present": "bare",
			"past": "bared"
		},
		{
			"present": "bat",
			"past": "batted"
		},
		{
			"present": "bathe",
			"past": "bathed"
		},
		{
			"present": "battle",
			"past": "battled"
		},
		{
			"present": "beam",
			"past": "beamed"
		},
		{
			"present": "beg",
			"past": "begged"
		},
		{
			"present": "behave",
			"past": "behaved"
		},
		{
			"present": "belong",
			"past": "belonged"
		},
		{
			"present": "bleach",
			"past": "bleached"
		},
		{
			"present": "bless",
			"past": "blessed"
		},
		{
			"present": "blind",
			"past": "blinded"
		},
		{
			"present": "blink",
			"past": "blinked"
		},
		{
			"present": "blot",
			"past": "blotted"
		},
		{
			"present": "blush",
			"past": "blushed"
		},
		{
			"present": "boast",
			"past": "boasted"
		},
		{
			"present": "boil",
			"past": "boiled"
		},
		{
			"present": "bolt",
			"past": "bolted"
		},
		{
			"present": "bomb",
			"past": "bombed"
		},
		{
			"present": "book",
			"past": "booked"
		},
		{
			"present": "bore",
			"past": "bored"
		},
		{
			"present": "borrow",
			"past": "borrowed"
		},
		{
			"present": "bounce",
			"past": "bounced"
		},
		{
			"present": "bow",
			"past": "bowed"
		},
		{
			"present": "box",
			"past": "boxed"
		},
		{
			"present": "brake",
			"past": "braked"
		},
		{
			"present": "branch",
			"past": "branched"
		},
		{
			"present": "breathe",
			"past": "breathed"
		},
		{
			"present": "bruise",
			"past": "bruised"
		},
		{
			"present": "brush",
			"past": "brushed"
		},
		{
			"present": "bubble",
			"past": "bubbled"
		},
		{
			"present": "bump",
			"past": "bumped"
		},
		{
			"present": "burn",
			"past": "burned"
		},
		{
			"present": "bury",
			"past": "buried"
		},
		{
			"present": "buzz",
			"past": "buzzed"
		},
		{
			"present": "calculate",
			"past": "calculated"
		},
		{
			"present": "call",
			"past": "called"
		},
		{
			"present": "camp",
			"past": "camped"
		},
		{
			"present": "care",
			"past": "cared"
		},
		{
			"present": "carry",
			"past": "carried"
		},
		{
			"present": "carve",
			"past": "carved"
		},
		{
			"present": "cause",
			"past": "caused"
		},
		{
			"present": "challenge",
			"past": "challenged"
		},
		{
			"present": "change",
			"past": "changed"
		},
		{
			"present": "charge",
			"past": "charged"
		},
		{
			"present": "chase",
			"past": "chased"
		},
		{
			"present": "cheat",
			"past": "cheated"
		},
		{
			"present": "check",
			"past": "checked"
		},
		{
			"present": "cheer",
			"past": "cheered"
		},
		{
			"present": "chew",
			"past": "chewed"
		},
		{
			"present": "choke",
			"past": "choked"
		},
		{
			"present": "chop",
			"past": "chopped"
		},
		{
			"present": "claim",
			"past": "claimed"
		},
		{
			"present": "clap",
			"past": "clapped"
		},
		{
			"present": "clean",
			"past": "cleaned"
		},
		{
			"present": "clear",
			"past": "cleared"
		},
		{
			"present": "clip",
			"past": "clipped"
		},
		{
			"present": "close",
			"past": "closed"
		},
		{
			"present": "coach",
			"past": "coached"
		},
		{
			"present": "coil",
			"past": "coiled"
		},
		{
			"present": "collect",
			"past": "collected"
		},
		{
			"present": "colour",
			"past": "coloured"
		},
		{
			"present": "comb",
			"past": "combed"
		},
		{
			"present": "command",
			"past": "commanded"
		},
		{
			"present": "communicate",
			"past": "communicated"
		},
		{
			"present": "compare",
			"past": "compared"
		},
		{
			"present": "compete",
			"past": "competed"
		},
		{
			"present": "complain",
			"past": "complained"
		},
		{
			"present": "complete",
			"past": "completed"
		},
		{
			"present": "concentrate",
			"past": "concentrated"
		},
		{
			"present": "concern",
			"past": "concerned"
		},
		{
			"present": "confess",
			"past": "confessed"
		},
		{
			"present": "confuse",
			"past": "confused"
		},
		{
			"present": "connect",
			"past": "connected"
		},
		{
			"present": "consider",
			"past": "considered"
		},
		{
			"present": "consist",
			"past": "consisted"
		},
		{
			"present": "contain",
			"past": "contained"
		},
		{
			"present": "continue",
			"past": "continued"
		},
		{
			"present": "copy",
			"past": "copied"
		},
		{
			"present": "correct",
			"past": "corrected"
		},
		{
			"present": "cough",
			"past": "coughed"
		},
		{
			"present": "count",
			"past": "counted"
		},
		{
			"present": "cover",
			"past": "covered"
		},
		{
			"present": "crack",
			"past": "cracked"
		},
		{
			"present": "crash",
			"past": "crashed"
		},
		{
			"present": "crawl",
			"past": "crawled"
		},
		{
			"present": "cross",
			"past": "crossed"
		},
		{
			"present": "crush",
			"past": "crushed"
		},
		{
			"present": "cry",
			"past": "cried"
		},
		{
			"present": "cure",
			"past": "cured"
		},
		{
			"present": "curl",
			"past": "curled"
		},
		{
			"present": "curve",
			"past": "curved"
		},
		{
			"present": "cycle",
			"past": "cycled"
		},
		{
			"present": "dam",
			"past": "dammed"
		},
		{
			"present": "damage",
			"past": "damaged"
		},
		{
			"present": "dance",
			"past": "danced"
		},
		{
			"present": "dare",
			"past": "dared"
		},
		{
			"present": "decay",
			"past": "decayed"
		},
		{
			"present": "deceive",
			"past": "deceived"
		},
		{
			"present": "decide",
			"past": "decided"
		},
		{
			"present": "decorate",
			"past": "decorated"
		},
		{
			"present": "delay",
			"past": "delayed"
		},
		{
			"present": "delight",
			"past": "delighted"
		},
		{
			"present": "deliver",
			"past": "delivered"
		},
		{
			"present": "depend",
			"past": "depended"
		},
		{
			"present": "describe",
			"past": "described"
		},
		{
			"present": "desert",
			"past": "deserted"
		},
		{
			"present": "deserve",
			"past": "deserved"
		},
		{
			"present": "destroy",
			"past": "destroyed"
		},
		{
			"present": "detect",
			"past": "detected"
		},
		{
			"present": "develop",
			"past": "developed"
		},
		{
			"present": "disagree",
			"past": "disagreed"
		},
		{
			"present": "disappear",
			"past": "disappeared"
		},
		{
			"present": "disapprove",
			"past": "disapproved"
		},
		{
			"present": "disarm",
			"past": "disarmed"
		},
		{
			"present": "discover",
			"past": "discovered"
		},
		{
			"present": "dislike",
			"past": "disliked"
		},
		{
			"present": "divide",
			"past": "divided"
		},
		{
			"present": "double",
			"past": "doubled"
		},
		{
			"present": "doubt",
			"past": "doubted"
		},
		{
			"present": "drag",
			"past": "dragged"
		},
		{
			"present": "drain",
			"past": "drained"
		},
		{
			"present": "dream",
			"past": "dreamed"
		},
		{
			"present": "dress",
			"past": "dressed"
		},
		{
			"present": "drip",
			"past": "dripped"
		},
		{
			"present": "drop",
			"past": "dropped"
		},
		{
			"present": "drown",
			"past": "drowned"
		},
		{
			"present": "drum",
			"past": "drummed"
		},
		{
			"present": "dry",
			"past": "dried"
		},
		{
			"present": "dust",
			"past": "dusted"
		},
		{
			"present": "earn",
			"past": "earned"
		},
		{
			"present": "educate",
			"past": "educated"
		},
		{
			"present": "embarrass",
			"past": "embarrassed"
		},
		{
			"present": "employ",
			"past": "employed"
		},
		{
			"present": "empty",
			"past": "emptied"
		},
		{
			"present": "encourage",
			"past": "encouraged"
		},
		{
			"present": "end",
			"past": "ended"
		},
		{
			"present": "enjoy",
			"past": "enjoyed"
		},
		{
			"present": "enter",
			"past": "entered"
		},
		{
			"present": "entertain",
			"past": "entertained"
		},
		{
			"present": "escape",
			"past": "escaped"
		},
		{
			"present": "examine",
			"past": "examined"
		},
		{
			"present": "excite",
			"past": "excited"
		},
		{
			"present": "excuse",
			"past": "excused"
		},
		{
			"present": "exercise",
			"past": "exercised"
		},
		{
			"present": "exist",
			"past": "existed"
		},
		{
			"present": "expand",
			"past": "expand"
		},
		{
			"present": "expect",
			"past": "expected"
		},
		{
			"present": "explain",
			"past": "explained"
		},
		{
			"present": "explode",
			"past": "exploded"
		},
		{
			"present": "extend",
			"past": "extended"
		},
		{
			"present": "face",
			"past": "faced"
		},
		{
			"present": "fade",
			"past": "faded"
		},
		{
			"present": "fail",
			"past": "failed"
		},
		{
			"present": "fancy",
			"past": "fancied"
		},
		{
			"present": "fasten",
			"past": "fastened"
		},
		{
			"present": "fax",
			"past": "faxed"
		},
		{
			"present": "fear",
			"past": "feared"
		},
		{
			"present": "fence",
			"past": "fenced"
		},
		{
			"present": "fetch",
			"past": "fetched"
		},
		{
			"present": "file",
			"past": "filed"
		},
		{
			"present": "fill",
			"past": "filled"
		},
		{
			"present": "film",
			"past": "filmed"
		},
		{
			"present": "fire",
			"past": "fired"
		},
		{
			"present": "fit",
			"past": "fitted"
		},
		{
			"present": "fix",
			"past": "fixed"
		},
		{
			"present": "flap",
			"past": "flapped"
		},
		{
			"present": "flash",
			"past": "flashed"
		},
		{
			"present": "float",
			"past": "floated"
		},
		{
			"present": "flood",
			"past": "flooded"
		},
		{
			"present": "flow",
			"past": "flowed"
		},
		{
			"present": "flower",
			"past": "flowered"
		},
		{
			"present": "fold",
			"past": "folded"
		},
		{
			"present": "follow",
			"past": "followed"
		},
		{
			"present": "fool",
			"past": "fooled"
		},
		{
			"present": "force",
			"past": "forced"
		},
		{
			"present": "form",
			"past": "formed"
		},
		{
			"present": "found",
			"past": "founded"
		},
		{
			"present": "frame",
			"past": "framed"
		},
		{
			"present": "frighten",
			"past": "frightened"
		},
		{
			"present": "fry",
			"past": "fried"
		},
		{
			"present": "gather",
			"past": "gathered"
		},
		{
			"present": "gaze",
			"past": "gazed"
		},
		{
			"present": "glow",
			"past": "glowed"
		},
		{
			"present": "glue",
			"past": "glued"
		},
		{
			"present": "grab",
			"past": "grabbed"
		},
		{
			"present": "grate",
			"past": "grated"
		},
		{
			"present": "grease",
			"past": "greased"
		},
		{
			"present": "greet",
			"past": "greeted"
		},
		{
			"present": "grin",
			"past": "grinned"
		},
		{
			"present": "grip",
			"past": "gripped"
		},
		{
			"present": "groan",
			"past": "groaned"
		},
		{
			"present": "guarantee",
			"past": "guaranteed"
		},
		{
			"present": "guard",
			"past": "guarded"
		},
		{
			"present": "guess",
			"past": "guessed"
		},
		{
			"present": "guide",
			"past": "guided"
		},
		{
			"present": "hammer",
			"past": "hammered"
		},
		{
			"present": "hand",
			"past": "handed"
		},
		{
			"present": "handle",
			"past": "handled"
		},
		{
			"present": "hang",
			"past": "hung"
		},
		{
			"present": "happen",
			"past": "happened"
		},
		{
			"present": "harass",
			"past": "harassed"
		},
		{
			"present": "harm",
			"past": "harmed"
		},
		{
			"present": "hate",
			"past": "hated"
		},
		{
			"present": "haunt",
			"past": "haunted"
		},
		{
			"present": "head",
			"past": "headed"
		},
		{
			"present": "heal",
			"past": "healed"
		},
		{
			"present": "heap",
			"past": "heaped"
		},
		{
			"present": "heat",
			"past": "heated"
		},
		{
			"present": "help",
			"past": "helped"
		},
		{
			"present": "hook",
			"past": "hooked"
		},
		{
			"present": "hop",
			"past": "hopped"
		},
		{
			"present": "hope",
			"past": "hoped"
		},
		{
			"present": "hover",
			"past": "hovered"
		},
		{
			"present": "hug",
			"past": "hugged"
		},
		{
			"present": "hum",
			"past": "hummed"
		},
		{
			"present": "hunt",
			"past": "hunted"
		},
		{
			"present": "hurry",
			"past": "hurried"
		},
		{
			"present": "identify",
			"past": "identified"
		},
		{
			"present": "ignore",
			"past": "ignored"
		},
		{
			"present": "imagine",
			"past": "imagined"
		},
		{
			"present": "impress",
			"past": "impressed"
		},
		{
			"present": "improve",
			"past": "improved"
		},
		{
			"present": "include",
			"past": "included"
		},
		{
			"present": "increase",
			"past": "increased"
		},
		{
			"present": "influence",
			"past": "influenced"
		},
		{
			"present": "inform",
			"past": "informed"
		},
		{
			"present": "inject",
			"past": "injected"
		},
		{
			"present": "injure",
			"past": "injured"
		},
		{
			"present": "instruct",
			"past": "instructed"
		},
		{
			"present": "intend",
			"past": "intended"
		},
		{
			"present": "interest",
			"past": "interested"
		},
		{
			"present": "interfere",
			"past": "interfered"
		},
		{
			"present": "interrupt",
			"past": "interrupted"
		},
		{
			"present": "introduce",
			"past": "introduced"
		},
		{
			"present": "invent",
			"past": "invented"
		},
		{
			"present": "invite",
			"past": "invited"
		},
		{
			"present": "irritate",
			"past": "irritated"
		},
		{
			"present": "itch",
			"past": "itched"
		},
		{
			"present": "jail",
			"past": "jailed"
		},
		{
			"present": "jam",
			"past": "jammed"
		},
		{
			"present": "jog",
			"past": "jogged"
		},
		{
			"present": "join",
			"past": "joined"
		},
		{
			"present": "joke",
			"past": "joked"
		},
		{
			"present": "judge",
			"past": "judged"
		},
		{
			"present": "juggle",
			"past": "juggled"
		},
		{
			"present": "jump",
			"past": "jumped"
		},
		{
			"present": "kick",
			"past": "kicked"
		},
		{
			"present": "kill",
			"past": "killed"
		},
		{
			"present": "kiss",
			"past": "kissed"
		},
		{
			"present": "kneel",
			"past": "knelt"
		},
		{
			"present": "knit",
			"past": "knitted"
		},
		{
			"present": "knock",
			"past": "knocked"
		},
		{
			"present": "knot",
			"past": "knotted"
		},
		{
			"present": "label",
			"past": "labelled"
		},
		{
			"present": "land",
			"past": "landed"
		},
		{
			"present": "last",
			"past": "lasted"
		},
		{
			"present": "laugh",
			"past": "laughed"
		},
		{
			"present": "launch",
			"past": "launched"
		},
		{
			"present": "learn",
			"past": "learned"
		},
		{
			"present": "level",
			"past": "levelled"
		},
		{
			"present": "license",
			"past": "licensed"
		},
		{
			"present": "lick",
			"past": "licked"
		},
		{
			"present": "lie",
			"past": "lied"
		},
		{
			"present": "lighten",
			"past": "lightened"
		},
		{
			"present": "like",
			"past": "liked"
		},
		{
			"present": "list",
			"past": "listed"
		},
		{
			"present": "listen",
			"past": "listened"
		},
		{
			"present": "live",
			"past": "lived"
		},
		{
			"present": "load",
			"past": "loaded"
		},
		{
			"present": "lock",
			"past": "locked"
		},
		{
			"present": "long",
			"past": "longed"
		},
		{
			"present": "look",
			"past": "look"
		},
		{
			"present": "love",
			"past": "loved"
		},
		{
			"present": "man",
			"past": "manned"
		},
		{
			"present": "manage",
			"past": "managed"
		},
		{
			"present": "march",
			"past": "marched"
		},
		{
			"present": "mark",
			"past": "marked"
		},
		{
			"present": "marry",
			"past": "married"
		},
		{
			"present": "match",
			"past": "matched"
		},
		{
			"present": "mate",
			"past": "mated"
		},
		{
			"present": "matter",
			"past": "mattered"
		},
		{
			"present": "measure",
			"past": "measured"
		},
		{
			"present": "meddle",
			"past": "meddled"
		},
		{
			"present": "melt",
			"past": "melted"
		},
		{
			"present": "memorise",
			"past": "memorised"
		},
		{
			"present": "mend",
			"past": "mended"
		},
		{
			"present": "mess up",
			"past": "messed up"
		},
		{
			"present": "milk",
			"past": "milked"
		},
		{
			"present": "mine",
			"past": "mined"
		},
		{
			"present": "miss",
			"past": "missed"
		},
		{
			"present": "mix",
			"past": "mixed"
		},
		{
			"present": "moan",
			"past": "moaned"
		},
		{
			"present": "moor",
			"past": "moored"
		},
		{
			"present": "mourn",
			"past": "mourned"
		},
		{
			"present": "move",
			"past": "moved"
		},
		{
			"present": "muddle",
			"past": "muddled"
		},
		{
			"present": "mug",
			"past": "mugged"
		},
		{
			"present": "multiply",
			"past": "multiplied"
		},
		{
			"present": "murder",
			"past": "murdered"
		},
		{
			"present": "nail",
			"past": "nailed"
		},
		{
			"present": "name",
			"past": "named"
		},
		{
			"present": "need",
			"past": "needed"
		},
		{
			"present": "nest",
			"past": "nested"
		},
		{
			"present": "nod",
			"past": "nodded"
		},
		{
			"present": "note",
			"past": "noted"
		},
		{
			"present": "notice",
			"past": "noticed"
		},
		{
			"present": "number",
			"past": "numbered"
		},
		{
			"present": "obey",
			"past": "obeyed"
		},
		{
			"present": "object",
			"past": "objected"
		},
		{
			"present": "observe",
			"past": "observed"
		},
		{
			"present": "obtain",
			"past": "obtained"
		},
		{
			"present": "occur",
			"past": "occurred"
		},
		{
			"present": "offend",
			"past": "offended"
		},
		{
			"present": "offer",
			"past": "offered"
		},
		{
			"present": "open",
			"past": "opened"
		},
		{
			"present": "order",
			"past": "ordered"
		},
		{
			"present": "overflow",
			"past": "overflowed"
		},
		{
			"present": "owe",
			"past": "owed"
		},
		{
			"present": "own",
			"past": "owned"
		},
		{
			"present": "pack",
			"past": "packed"
		},
		{
			"present": "paddle",
			"past": "paddled"
		},
		{
			"present": "paint",
			"past": "painted"
		},
		{
			"present": "park",
			"past": "parked"
		},
		{
			"present": "part",
			"past": "parted"
		},
		{
			"present": "pass",
			"past": "passed"
		},
		{
			"present": "paste",
			"past": "pasted"
		},
		{
			"present": "pat",
			"past": "patted"
		},
		{
			"present": "pause",
			"past": "paused"
		},
		{
			"present": "peck",
			"past": "pecked"
		},
		{
			"present": "pedal",
			"past": "pedalled"
		},
		{
			"present": "peel",
			"past": "peeled"
		},
		{
			"present": "peep",
			"past": "peeped"
		},
		{
			"present": "perform",
			"past": "performed"
		},
		{
			"present": "permit",
			"past": "permitted"
		},
		{
			"present": "phone",
			"past": "phoned"
		},
		{
			"present": "pick",
			"past": "picked"
		},
		{
			"present": "pinch",
			"past": "pinched"
		},
		{
			"present": "pine",
			"past": "pined"
		},
		{
			"present": "place",
			"past": "placed"
		},
		{
			"present": "plan",
			"past": "planned"
		},
		{
			"present": "plant",
			"past": "planted"
		},
		{
			"present": "play",
			"past": "played"
		},
		{
			"present": "please",
			"past": "pleased"
		},
		{
			"present": "plug",
			"past": "plugged"
		},
		{
			"present": "point",
			"past": "pointed"
		},
		{
			"present": "poke",
			"past": "poked"
		},
		{
			"present": "polish",
			"past": "polished"
		},
		{
			"present": "pop",
			"past": "popped"
		},
		{
			"present": "possess",
			"past": "possessed"
		},
		{
			"present": "post",
			"past": "posted"
		},
		{
			"present": "pour",
			"past": "poured"
		},
		{
			"present": "practise",
			"past": "practised"
		},
		{
			"present": "pray",
			"past": "prayed"
		},
		{
			"present": "preach",
			"past": "preached"
		},
		{
			"present": "precede",
			"past": "preceded"
		},
		{
			"present": "prefer",
			"past": "preferred"
		},
		{
			"present": "prepare",
			"past": "prepared"
		},
		{
			"present": "present",
			"past": "presented"
		},
		{
			"present": "preserve",
			"past": "preserved"
		},
		{
			"present": "press",
			"past": "pressed"
		},
		{
			"present": "pretend",
			"past": "pretended"
		},
		{
			"present": "prevent",
			"past": "prevented"
		},
		{
			"present": "prick",
			"past": "pricked"
		},
		{
			"present": "print",
			"past": "printed"
		},
		{
			"present": "produce",
			"past": "produced"
		},
		{
			"present": "program",
			"past": "programmed"
		},
		{
			"present": "promise",
			"past": "promised"
		},
		{
			"present": "protect",
			"past": "protected"
		},
		{
			"present": "provide",
			"past": "provided"
		},
		{
			"present": "pull",
			"past": "pulled"
		},
		{
			"present": "pump",
			"past": "pumped"
		},
		{
			"present": "punch",
			"past": "punched"
		},
		{
			"present": "puncture",
			"past": "punctured"
		},
		{
			"present": "punish",
			"past": "punished"
		},
		{
			"present": "push",
			"past": "pushed"
		},
		{
			"present": "question",
			"past": "questioned"
		},
		{
			"present": "queue",
			"past": "questioned"
		},
		{
			"present": "race",
			"past": "raced"
		},
		{
			"present": "radiate",
			"past": "radiated"
		},
		{
			"present": "rain",
			"past": "rained"
		},
		{
			"present": "raise",
			"past": "raised"
		},
		{
			"present": "reach",
			"past": "reached"
		},
		{
			"present": "realise",
			"past": "realised"
		},
		{
			"present": "receive",
			"past": "received"
		},
		{
			"present": "recognise",
			"past": "recognised"
		},
		{
			"present": "record",
			"past": "recorded"
		},
		{
			"present": "reduce",
			"past": "reduced"
		},
		{
			"present": "reflect",
			"past": "reflected"
		},
		{
			"present": "refuse",
			"past": "refused"
		},
		{
			"present": "regret",
			"past": "regretted"
		},
		{
			"present": "reign",
			"past": "reigned"
		},
		{
			"present": "reject",
			"past": "rejected"
		},
		{
			"present": "rejoice",
			"past": "rejoiced"
		},
		{
			"present": "relax",
			"past": "relaxed"
		},
		{
			"present": "release",
			"past": "released"
		},
		{
			"present": "rely",
			"past": "relied"
		},
		{
			"present": "remain",
			"past": "remained"
		},
		{
			"present": "remember",
			"past": "remembered"
		},
		{
			"present": "remind",
			"past": "reminded"
		},
		{
			"present": "remove",
			"past": "removed"
		},
		{
			"present": "repair",
			"past": "repaired"
		},
		{
			"present": "repeat",
			"past": "repeated"
		},
		{
			"present": "replace",
			"past": "replaced"
		},
		{
			"present": "reply",
			"past": "replied"
		},
		{
			"present": "report",
			"past": "reported"
		},
		{
			"present": "reproduce",
			"past": "reproduced"
		},
		{
			"present": "request",
			"past": "requested"
		},
		{
			"present": "rescue",
			"past": "rescued"
		},
		{
			"present": "retire",
			"past": "retired"
		},
		{
			"present": "return",
			"past": "returned"
		},
		{
			"present": "rhyme",
			"past": "rhyme"
		},
		{
			"present": "rinse",
			"past": "rinsed"
		},
		{
			"present": "risk",
			"past": "risked"
		},
		{
			"present": "rob",
			"past": "robbed"
		},
		{
			"present": "rock",
			"past": "rocked"
		},
		{
			"present": "roll",
			"past": "rolled"
		},
		{
			"present": "rot",
			"past": "rotted"
		},
		{
			"present": "rub",
			"past": "rubbed"
		},
		{
			"present": "ruin",
			"past": "ruined"
		},
		{
			"present": "rule",
			"past": "ruled"
		},
		{
			"present": "rush",
			"past": "rushed"
		},
		{
			"present": "sack",
			"past": "sacked"
		},
		{
			"present": "sail",
			"past": "sailed"
		},
		{
			"present": "satisfy",
			"past": "satisfied"
		},
		{
			"present": "save",
			"past": "saved"
		},
		{
			"present": "saw",
			"past": "sawed"
		},
		{
			"present": "scare",
			"past": "scared"
		},
		{
			"present": "scatter",
			"past": "scattered"
		},
		{
			"present": "scold",
			"past": "scolded"
		},
		{
			"present": "scorch",
			"past": "scorched"
		},
		{
			"present": "scrape",
			"past": "scraped"
		},
		{
			"present": "scratch",
			"past": "scratched"
		},
		{
			"present": "scream",
			"past": "screamed"
		},
		{
			"present": "screw",
			"past": "screwed"
		},
		{
			"present": "scribble",
			"past": "scribbled"
		},
		{
			"present": "scrub",
			"past": "scrubbed"
		},
		{
			"present": "seal",
			"past": "sealed"
		},
		{
			"present": "search",
			"past": "searched"
		},
		{
			"present": "separate",
			"past": "separate"
		},
		{
			"present": "serve",
			"past": "served"
		},
		{
			"present": "settle",
			"past": "settled"
		},
		{
			"present": "shade",
			"past": "shaded"
		},
		{
			"present": "share",
			"past": "shared"
		},
		{
			"present": "shave",
			"past": "shaved"
		},
		{
			"present": "shelter",
			"past": "sheltered"
		},
		{
			"present": "shiver",
			"past": "shivered"
		},
		{
			"present": "shock",
			"past": "shocked"
		},
		{
			"present": "shop",
			"past": "shopped"
		},
		{
			"present": "shrug",
			"past": "shrugged"
		},
		{
			"present": "sigh",
			"past": "sighed"
		},
		{
			"present": "sign",
			"past": "signed"
		},
		{
			"present": "signal",
			"past": "signalled"
		},
		{
			"present": "sin",
			"past": "sinned"
		},
		{
			"present": "sip",
			"past": "sipped"
		},
		{
			"present": "ski",
			"past": "skied"
		},
		{
			"present": "skip",
			"past": "skipped"
		},
		{
			"present": "slap",
			"past": "slapped"
		},
		{
			"present": "slip",
			"past": "slipped"
		},
		{
			"present": "slow",
			"past": "slowed"
		},
		{
			"present": "smash",
			"past": "smashed"
		},
		{
			"present": "smell",
			"past": "smelled"
		},
		{
			"present": "smile",
			"past": "smiled"
		},
		{
			"present": "smoke",
			"past": "smoked"
		},
		{
			"present": "snatch",
			"past": "snatched"
		},
		{
			"present": "sneeze",
			"past": "sneezed"
		},
		{
			"present": "sniff",
			"past": "sniffed"
		},
		{
			"present": "snore",
			"past": "snored"
		},
		{
			"present": "snow",
			"past": "snowed"
		},
		{
			"present": "soak",
			"past": "soaked"
		},
		{
			"present": "soothe",
			"past": "soothed"
		},
		{
			"present": "sound",
			"past": "sounded"
		},
		{
			"present": "spare",
			"past": "spared"
		},
		{
			"present": "spark",
			"past": "sparked"
		},
		{
			"present": "sparkle",
			"past": "sparkled"
		},
		{
			"present": "spell",
			"past": "spelled"
		},
		{
			"present": "spill",
			"past": "spilled"
		},
		{
			"present": "spoil",
			"past": "spoiled"
		},
		{
			"present": "spot",
			"past": "spotted"
		},
		{
			"present": "spray",
			"past": "sprayed"
		},
		{
			"present": "sprout",
			"past": "sprouted"
		},
		{
			"present": "squash",
			"past": "squashed"
		},
		{
			"present": "squeak",
			"past": "squeaked"
		},
		{
			"present": "squeal",
			"past": "squealed"
		},
		{
			"present": "squeeze",
			"past": "squeezed"
		},
		{
			"present": "stain",
			"past": "stained"
		},
		{
			"present": "stamp",
			"past": "stamped"
		},
		{
			"present": "stare",
			"past": "stared"
		},
		{
			"present": "start",
			"past": "started"
		},
		{
			"present": "stay",
			"past": "stayed"
		},
		{
			"present": "steer",
			"past": "steered"
		},
		{
			"present": "step",
			"past": "stepped"
		},
		{
			"present": "stir",
			"past": "stirred"
		},
		{
			"present": "stitch",
			"past": "stitched"
		},
		{
			"present": "stop",
			"past": "stopped"
		},
		{
			"present": "store",
			"past": "stored"
		},
		{
			"present": "strap",
			"past": "strapped"
		},
		{
			"present": "strengthen",
			"past": "strengthened"
		},
		{
			"present": "stretch",
			"past": "stretched"
		},
		{
			"present": "strip",
			"past": "stripped"
		},
		{
			"present": "stroke",
			"past": "stroked"
		},
		{
			"present": "stuff",
			"past": "stuffed"
		},
		{
			"present": "subtract",
			"past": "subtracted"
		},
		{
			"present": "succeed",
			"past": "succeeded"
		},
		{
			"present": "suck",
			"past": "sucked"
		},
		{
			"present": "suffer",
			"past": "suffered"
		},
		{
			"present": "suggest",
			"past": "suggested"
		},
		{
			"present": "suit",
			"past": "suited"
		},
		{
			"present": "supply",
			"past": "supplied"
		},
		{
			"present": "support",
			"past": "supported"
		},
		{
			"present": "suppose",
			"past": "supposed"
		},
		{
			"present": "surprise",
			"past": "surprised"
		},
		{
			"present": "surround",
			"past": "surrounded"
		},
		{
			"present": "suspect",
			"past": "suspected"
		},
		{
			"present": "suspend",
			"past": "suspended"
		},
		{
			"present": "switch",
			"past": "switched"
		},
		{
			"present": "talk",
			"past": "talked"
		},
		{
			"present": "tame",
			"past": "tamed"
		},
		{
			"present": "tap",
			"past": "tapped"
		},
		{
			"present": "taste",
			"past": "tasted"
		},
		{
			"present": "tease",
			"past": "teased"
		},
		{
			"present": "telephone",
			"past": "telephoned"
		},
		{
			"present": "tempt",
			"past": "tempted"
		},
		{
			"present": "terrify",
			"past": "terrified"
		},
		{
			"present": "test",
			"past": "tested"
		},
		{
			"present": "thank",
			"past": "thanked"
		},
		{
			"present": "thaw",
			"past": "thawed"
		},
		{
			"present": "tick",
			"past": "ticked"
		},
		{
			"present": "tickle",
			"past": "tickled"
		},
		{
			"present": "tie",
			"past": "tied"
		},
		{
			"present": "time",
			"past": "timed"
		},
		{
			"present": "tip",
			"past": "tipped"
		},
		{
			"present": "tire",
			"past": "tired"
		},
		{
			"present": "touch",
			"past": "touched"
		},
		{
			"present": "tour",
			"past": "toured"
		},
		{
			"present": "tow",
			"past": "towed"
		},
		{
			"present": "trace",
			"past": "traced"
		},
		{
			"present": "trade",
			"past": "traded"
		},
		{
			"present": "train",
			"past": "trained"
		},
		{
			"present": "transport",
			"past": "transported"
		},
		{
			"present": "trap",
			"past": "trapped"
		},
		{
			"present": "travel",
			"past": "travelled"
		},
		{
			"present": "treat",
			"past": "treated"
		},
		{
			"present": "tremble",
			"past": "trembled"
		},
		{
			"present": "trick",
			"past": "tricked"
		},
		{
			"present": "trip",
			"past": "tripped"
		},
		{
			"present": "trot",
			"past": "trotted"
		},
		{
			"present": "trouble",
			"past": "troubled"
		},
		{
			"present": "trust",
			"past": "trusted"
		},
		{
			"present": "try",
			"past": "tried"
		},
		{
			"present": "tug",
			"past": "tugged"
		},
		{
			"present": "tumble",
			"past": "tumbled"
		},
		{
			"present": "turn",
			"past": "turned"
		},
		{
			"present": "twist",
			"past": "twisted"
		},
		{
			"present": "type",
			"past": "typed"
		},
		{
			"present": "undress",
			"past": "undressed"
		},
		{
			"present": "unfasten",
			"past": "unfastened"
		},
		{
			"present": "unite",
			"past": "united"
		},
		{
			"present": "unlock",
			"past": "unlocked"
		},
		{
			"present": "unpack",
			"past": "unpacked"
		},
		{
			"present": "untidy",
			"past": "untidied"
		},
		{
			"present": "use",
			"past": "used"
		},
		{
			"present": "vanish",
			"past": "vanished"
		},
		{
			"present": "visit",
			"past": "visited"
		},
		{
			"present": "wail",
			"past": "wailed"
		},
		{
			"present": "wait",
			"past": "waited"
		},
		{
			"present": "walk",
			"past": "walked"
		},
		{
			"present": "wander",
			"past": "wandered"
		},
		{
			"present": "want",
			"past": "wanted"
		},
		{
			"present": "warm",
			"past": "warmed"
		},
		{
			"present": "warn",
			"past": "warned"
		},
		{
			"present": "wash",
			"past": "washed"
		},
		{
			"present": "waste",
			"past": "wasted"
		},
		{
			"present": "watch",
			"past": "watched"
		},
		{
			"present": "water",
			"past": "watered"
		},
		{
			"present": "wave",
			"past": "waved"
		},
		{
			"present": "weigh",
			"past": "weighed"
		},
		{
			"present": "welcome",
			"past": "welcomed"
		},
		{
			"present": "whine",
			"past": "whined"
		},
		{
			"present": "whip",
			"past": "whipped"
		},
		{
			"present": "whirl",
			"past": "whirled"
		},
		{
			"present": "whisper",
			"past": "whispered"
		},
		{
			"present": "whistle",
			"past": "whistled"
		},
		{
			"present": "wink",
			"past": "winked"
		},
		{
			"present": "wipe",
			"past": "wiped"
		},
		{
			"present": "wish",
			"past": "wished"
		},
		{
			"present": "wobble",
			"past": "wobbled"
		},
		{
			"present": "wonder",
			"past": "wondered"
		},
		{
			"present": "work",
			"past": "worked"
		},
		{
			"present": "worry",
			"past": "worried"
		},
		{
			"present": "wrap",
			"past": "wrapped"
		},
		{
			"present": "wreck",
			"past": "wrecked"
		},
		{
			"present": "wrestle",
			"past": "wrestled"
		},
		{
			"present": "wriggle",
			"past": "wriggled"
		},
		{
			"present": "x-ray",
			"past": "x-rayed"
		},
		{
			"present": "yawn",
			"past": "yawned"
		},
		{
			"present": "yell",
			"past": "yelled"
		},
		{
			"present": "zip",
			"past": "zipped"
		},
		{
			"present": "zoom",
			"past": "zoomed"
		}
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/words/verbs.json
 **/